import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpUtils } from '../utils/httpUtils';

@Injectable({
  providedIn: 'root'
})
export class EssayExecutionAirFilesService {

  constructor(private http: HttpClient) { }

  getAllByIdEssay(idEssay: number): Observable<any> {
    const url = `${environment.airUrl}/essayExecutionAirFiles/essay/${idEssay}`;
    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }
}
